import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_ID } from '@angular/core';
// import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppFooterComponent } from './template/app-footer/app-footer.component';
import {far} from '@fortawesome/free-regular-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {
    FontAwesomeModule,
    FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import {fas} from '@fortawesome/free-solid-svg-icons';

import { JournalService } from './journal/journal.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnvServiceProvider } from '././services/env.service.provider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppHeaderComponent } from './template/app-header/app-header.component';
import { HighlightSearchPipe } from './common/pipe/highlight-search.pipe';
import { RvhostLoaderComponent } from './misc/rvhost-loader/rvhost-loader.component';
import { CommonPipesModule } from './common/commonpipes.module';
import { JournalModule } from './journal/journal.module';
// import { BookModule } from './book/book.module';
import { HomeModule } from './home/home.module';
import { UserModule } from './user/user.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ResetPasswordComponent } from './common/reset-password/reset-password.component';
import { UniversalStorageService } from './services/universal-storage.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LanguageLoader } from './load-language';
import { EnvService } from './services/env.service';
// import { ProceedingsModule } from './proceedings/proceedings.module';
// import { ContactUsModule } from './contact-us/contact-us.module';
import { CommonModule } from '@angular/common';
// import { FaqModule } from './faq/faq.module';
import { PublisherService } from './services/publisher.service';
import { TemplateModule } from './template/template.module';
import { NewsLetterComponent } from './misc/news-letter/news-letter.component';
import { NewsLetterService } from './services/news-letter.service';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './common/alert/alert.component';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { provideClientHydration } from '@angular/platform-browser';

// Define the configuration for NgcCookieConsentModule
const cookieConfig: NgcCookieConsentConfig = {
    "cookie": {
        "domain": "journal.thebritishacademy.ac.uk"
    },
    "position": "bottom",
    "theme": "classic",
    "palette": {
        "popup": {
          "background": "#ffffff",
          "text": "#2a2a2a",
          "link": "#2a2a2a"
        },
        "button": {
          "background": "#333132",
          "text": "#ffffff",
          "border": "#333132"
        }
    },
    "type": "opt-in",
    "content": {
        "header": "Your choice regarding cookies on this site",
        "message": "We use cookies to optimise site functionality and give you the best possible experience.",
        "dismiss": "Got it!",
        "deny": "Reject all cookies",
        "link": "Learn more",
        "href": "https://www.thebritishacademy.ac.uk/about/privacy-and-cookies/",
        "policy": "Cookie Policy",
        "allow": "Accept all cookies"
    }
}

@NgModule({
    declarations: [
        AppComponent,
        AppFooterComponent,
        AppHeaderComponent,
        RvhostLoaderComponent,
        ResetPasswordComponent,
        NewsLetterComponent,
        AlertComponent

    ],
    imports: [
        // BrowserModule.withServerTransition({ appId: 'app' }),
        BrowserAnimationsModule,
        AppRoutingModule,
        CommonModule,
        FontAwesomeModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        CommonPipesModule,
        JournalModule,
        // BookModule,
        HomeModule,
        NgxCaptchaModule,
        UserModule,
        // ProceedingsModule,
        // ContactUsModule,
        // FaqModule,
        TemplateModule,
        ShareButtonsModule,
        ShareIconsModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en-GB',
            loader: {
                provide: TranslateLoader,
                useClass: LanguageLoader,
                deps: [HttpClient, EnvService],
            },
        }),
        NgcCookieConsentModule.forRoot(cookieConfig),
        GoogleTagManagerModule.forRoot({
            id: 'G-GFM3FBT5MR', 
          }),
        
    ],
    providers: [
      { provide: APP_ID, useValue: 'app' },
        // Reuses the server-rendered DOM on the client instead of destroying and rebuilding it
        // on bootstrap (Angular Universal's default without this). That destroy-and-rebuild is
        // what made every section flash back to its loading skeleton right after a real,
        // content-complete SSR response, then repopulate section-by-section as each one's data
        // became available again - the "one section loads, nothing else does" behavior. Includes
        // an HTTP transfer cache by default, so a separate TransferHttpCacheModule isn't needed.
        provideClientHydration(),
        JournalService,
        UniversalStorageService,
        EnvServiceProvider,
        PublisherService,
        HighlightSearchPipe,
        NewsLetterService,
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: AuthInterceptor,
        //     multi: true,
        // },  
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas, far, fab);
        // library.addIcons(
        //     faUser,
        //     faHeart,
        //     faList,
        //     faCartShopping,
        //     faFacebook,
        //     faYoutube,
        //     faDropbox,
        //     faTwitter,
        //     faRightLong,
        //     faBookmark,
        //     faArrowRight,
        //     faBuildingColumns,
        //     faStar,
        //     faStarHalfStroke,
        //     faCartPlus
        // );
    }
}
